import { InjectionToken } from '@angular/core';
import { GlobalEnvironment } from '../interfaces/global-environment.interface';

export const ENVIRONMENT = new InjectionToken<GlobalEnvironment>('ENVIRONMENT');
